import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.25 1.5h2.25A1.5 1.5 0 0 1 18 3v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 0 18V3a1.5 1.5 0 0 1 1.5-1.5h2.25V.75a.75.75 0 0 1 1.5 0v.75h7.5V.75a.75.75 0 0 1 1.5 0zM3.75 3.75V3H1.5v3h15V3h-2.25v.75a.75.75 0 0 1-1.5 0V3h-7.5v.75a.75.75 0 0 1-1.5 0M16.5 18h-15V7.5h15zm-3.61-6.956a.75.75 0 0 0 .029-1.06.74.74 0 0 0-1.06-.028l-3.862 3.638L6.14 11.83a.75.75 0 1 0-1.032 1.088l2.372 2.25a.74.74 0 0 0 .516.206.72.72 0 0 0 .515-.206z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }